<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="row">
        <div class="col-md-12">
          <label class="ts-text-xs required">{{
            $t('gameSet.gameSettingName')
          }}</label>
          <a-select
            class="ts-w-full"
            v-model.number="model.game_setting_id"
            :options="game_settings"
            @change="gameSettingChange"
          ></a-select>
          <div class="validate ts-text-xs" v-if="errors.has('game_setting_id')">
            {{ errors.first('game_setting_id') }}
          </div>
        </div>
      </div>
      <div class="row ts-mt-3">
        <div class="col-md-12">
          <label class="ts-text-xs required">{{
            $t('gameSet.gameSetName')
          }}</label>
          <input
            type="text"
            class="form-control"
            v-model.trim="model.game_set_name"
          />
          <div class="validate ts-text-xs" v-if="errors.has('game_set_name')">
            {{ errors.first('game_set_name') }}
          </div>
        </div>
      </div>
      <div class="row ts-mt-3" v-if="show_jackpot">
        <div class="col-md-12">
          <label class="ts-text-xs required">{{ $t('gameSet.jackpot') }}</label>
          <input
            type="number"
            class="form-control"
            v-model.number="model.jackpot"
          />
          <div class="validate ts-text-xs" v-if="errors.has('jackpot')">
            {{ errors.first('jackpot') }}
          </div>
        </div>
      </div>
      <div class="row ts-mt-3">
        <div :class="!isEdit ? 'col-md-6' : 'col-md-12'">
          <label class="ts-text-xs required">{{
            $t('gameSet.resultDate')
          }}</label>
          <a-date-picker
            format="DD-MM-YYYY"
            class="ts-w-full"
            v-model="model.result_date"
          />
          <div class="validate ts-text-xs" v-if="errors.has('result_date')">
            {{ errors.first('result_date') }}
          </div>
        </div>
        <div class="col-md-6" v-if="!isEdit">
          <label class="ts-text-xs">{{ $t('gameSet.numDayAfterNow') }}</label>
          <input
            type="number"
            class="form-control"
            v-model.number="model.day_after_now"
          />
        </div>
      </div>
      <div class="row ts-mt-3">
        <div class="col-md-12">
          <label class="ts-text-xs required">{{
            $t('gameSet.closeTime')
          }}</label>
          <a-time-picker
            format="HH:mm:ss"
            class="ts-w-full"
            v-model="model.close_time"
          />
          <div class="validate ts-text-xs" v-if="errors.has('close_time')">
            {{ errors.first('close_time') }}
          </div>
        </div>
      </div>
      <div class="row ts-mt-3">
        <div class="col-md-12">
          <label class="ts-text-xs required">{{ $t('gameSet.status') }}</label>
          <select class="form-control" v-model="model.status">
            <option value="Active">Active</option>
            <option value="Pending">Pending</option>
            <option value="Close">Close</option>
          </select>
        </div>
      </div>
      <div class="row ts-mt-4">
        <div class="col-md-12 ts-text-right ts-flex ts-justify-end">
          <ts-button class="mr-2" @click.prevent="$emit('close')">{{
            $t('cancel')
          }}</ts-button>
          <ts-button
            v-if="isEdit"
            color="primary"
            :waiting="updating"
            @click.prevent="onUpdate"
            >{{ $t('update') }}</ts-button
          >
          <div v-if="!isEdit">
            <ts-button
              class="mr-2"
              color="primary"
              outline
              :waiting="waiting_new"
              @click.prevent="onSaveNew"
              >{{ $t('save_add_new') }}</ts-button
            >
            <ts-button
              color="primary"
              :waiting="waiting"
              @click.prevent="onSave"
              >{{ $t('save') }}</ts-button
            >
          </div>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import moment from 'moment'

export default {
  name: 'gameSetFormCreateUpdate',
  data() {
    return {
      loading: false,
      waiting_new: false,
      waiting: false,
      updating: false,
      show_jackpot: true,
      errors: new Errors(),
      game_settings: [],
      game_lots: [],
      model: {
        game_set_id: 0,
        game_set_name: null,
        result_date: moment(),
        status: 'active',
        close_time: moment(),
        jackpot: null,
        game_setting_id: null,
        day_after_now: 0
      }
    }
  },
  created() {
    this.fetchData()
    this.setEditData()
  },
  computed: {
    ...mapState('administrator/gameSet', ['edit_data']),
    isEdit() {
      return !_.isEmpty(this.$store.state.administrator.gameSet.edit_data)
    }
  },
  methods: {
    ...mapActions('administrator/gameSet', [
      'getGameSetting',
      'store',
      'update'
    ]),
    fetchData() {
      this.loading = true
      this.getGameSetting()
        .then(response => {
          this.game_settings = response.data.map(el => ({
            value: el.game_setting_id,
            label: el.game_setting,
            game_type_id: el.game_type_id
          }))
          this.game_lots = [...response.data.map(el => el.game_lots).flat()]
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onUpdate() {
      this.errors = new Errors()
      this.updating = true
      this.update({
        id: this.model.game_set_id,
        data: Object.assign({}, this.model, {
          close_time: this.model.close_time.format('HH:mm:ss'),
          result_date: this.model.result_date.format('DD-MM-YYYY')
        })
      })
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('close')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.updating = false
        })
    },
    onSave() {
      this.errors = new Errors()
      this.waiting = true
      this.store(
        Object.assign({}, this.model, {
          close_time: this.model.close_time.format('HH:mm:ss'),
          result_date: this.model.result_date.format('DD-MM-YYYY')
        })
      )
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('close')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    onSaveNew() {
      this.errors = new Errors()
      this.waiting_new = true
      this.store(
        Object.assign({}, this.model, {
          close_time: this.model.close_time.format('HH:mm:ss'),
          result_date: this.model.result_date.format('DD-MM-YYYY')
        })
      )
        .then(response => {
          this.$toasted.success(response.message)
          this.clearInput()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting_new = false
        })
    },
    clearInput() {
      this.model.game_set_id = 0
      this.model.game_set_name = null
      this.model.result_date = moment()
      this.model.status = 'active'
      this.model.close_time = moment()
      this.model.jackpot = null
      this.model.game_setting_id = null
      this.model.day_after_now = 0
    },
    setEditData() {
      if (!_.isEmpty(this.edit_data)) {
        this.model.game_set_id = this.edit_data.game_set_id
        this.model.game_set_name = this.edit_data.game_set_name
        this.model.result_date = moment(
          this.edit_data.result_date,
          'DD-MM-YYYY'
        )
        this.model.status = this.edit_data.status
        this.model.close_time = moment(this.edit_data.close_time, 'HH:mm:ss')
        this.model.jackpot = this.edit_data.jackpot
        this.model.game_setting_id = this.edit_data.game_setting_id
        this.model.day_after_now = 0
      }
    },
    gameSettingChange(value, option) {
      if (option.data.props.game_type_id == 2) {
        this.model.jackpot = 0
        this.show_jackpot = false
      } else {
        this.show_jackpot = true
        this.model.jackpot = _.sumBy(
          this.game_lots.filter(
            g => g.game_setting_id == value && g.split_price == true
          ),
          s => s.odds
        )
      }
    }
  }
}
</script>
